import { type IApiAuthData } from "src/interfaces";

export const setApiAuthData = (authData: IApiAuthData) => {
  localStorage.setItem("authData", JSON.stringify(authData));
};

export const setYachtId = (_yachtid: string) => {
  const authData = getApiAuthData();
  localStorage.setItem("authData", JSON.stringify({ ...authData, _yachtid }));
};

export const getApiAuthData = (): IApiAuthData => {
  const authData = localStorage.getItem("authData");
  return JSON.parse(authData ?? "{}");
};

export const getYachtId = () => getApiAuthData()._yachtid;
export const getUserId = () => getApiAuthData()._userid;
